// x-consent-subtle.js

/*
For optional, subtle variant of uio cookie banner.
Requires less file of same name.

- Allows tab-flow outside of the first dialog.
- Timeouts to ensure dialog (loaded dynamically) is present before doing anything.
*/

export default function xConsentSubtle() {

  function handleConsentDialogs() {
    const consent = document.querySelector(".consent");
    if (consent) {
      console.debug("Consent first dialog present");
      const header = document.getElementById("header");
      const consentInner = consent.querySelector(".consent-inner");
      const consentCustomize = consent.querySelector(".consent-customize");

      // Remove dialog container from user tab-flow (only needed for js)
      consent.setAttribute("tabindex", -1);

      // First dialog: Control tab-flow for consent-customize link to allow tabbing outside container
      consentCustomize.addEventListener("keydown", (event) => {
        if (event.key === "Tab") {
          if (event.shiftKey) {
            consentInner.focus();
          } else {
            header.setAttribute("tabindex", -1);
            header.focus();
          }
        }
      });

      // Function to handle consent-settings (second) dialog
      function handleConsentSettings() {
        console.debug("Consent settings opened");
      }

      // Handle setting dialog when opened (clicking customize)
      consentCustomize.addEventListener("click", () => {
        setTimeout(handleConsentSettings, 1000);
      });
    }
  }

  // Initialize the script when the page loads. Timeout to ensure detection of consent dialog.
  window.addEventListener("load", () => {
    setTimeout(handleConsentDialogs, 1000);
  });
}